<custom-alert></custom-alert>
<ng-container *ngIf="isCodeValid">
  <section class="flex flex-column justify-content-center h-full flex-wrap align-content-center">
    <main class="app-card">
      <div class="logo my-4">
        <img src="assets/img/logo-tramitfly.png" alt="Logo tramitFly" class="img-logo"/>
        <img src="assets/img/logo-tramitfly-responsive.png" alt="Logo tramitFly" class="logo-responsive"/>
        <span class="text-black font-20 inline-flex justify-content-end font-medium">Tus trámites al instante</span>
      </div>
      <div class="flex justify-content-between pt-2 mx-auto gap-4">
        <div class="flex gap-1 align-items-center">
          <i class="pi pi-calendar" style="font-size: 1.4rem; color: var(--gray);"></i>
          <p class="text-gray my-0" style="font-size:13px"> {{ currentTime | date: 'dd/MM/YYYY' }} </p>
        </div>
        <div class="flex gap-1 align-items-center">
          <i class="pi pi-clock text-gray" style="font-size: 1.4rem;"></i>
          <p class="text-gray my-0" style="font-size:13px"> {{ currentTime | date: 'HH:mm' }} </p>
        </div>
        <div class="flex gap-1 align-items-center">
          <i class="pi pi-globe text-gray" style="font-size: 1.4rem;"></i>
          <p class="text-gray my-0" style="font-size:11px"> {{ location }} </p>
        </div>
      </div>
      <div class="flex justify-content-center flex-column align-items-center">
        <h3 class="font-bold mt-4 color-blue-2 " style="font-size:1.7rem;">{{ translations.welcome }}</h3>
      </div>
      <form [formGroup]="form" (ngSubmit)="onSubmit()" class="w-full">
        <div class="flex flex-column gap-2 mt-5">
          <main class="grid formgrid p-fluid">
            <div class="field col-12 ">
              <label for="password" class="blue-bold-text">{{ translations.contrasena }}<span
                style="color: red">*</span></label>
              <p-password id="password" formControlName="password" [toggleMask]="true">
                <ng-template pTemplate="footer">
                  <div>
                    <p-divider/>
                    <p class="mt-2 bold">{{ translations.sugerencias }}</p>
                    <ul class="pl-2 ml-2 mt-0" style="line-height: 1.5">
                      <li>{{ translations.alMenosUnaMinuscula }}</li>
                      <li>{{ translations.alMenosUnaMayuscula }}</li>
                      <li>{{ translations.alMenosUnNumero }}</li>
                      <li>{{ translations.minimoCaracteres }}</li>
                      <li>{{ translations.maximoCaracteres }}</li>
                      <li>{{ translations.alMenosUnCaracterEspecial }}</li>
                    </ul>
                  </div>
                </ng-template>
              </p-password>
              <ng-container *ngIf="form.get('password')?.touched">
                <app-form-group-error-message [control]="form.get('password')"></app-form-group-error-message>
                <small id="passwordRepeat-help" class="p-error block"
                       *ngIf="form.get('passwordRepeat')?.touched && form.errors?.['notMatch']">
                  {{ translations.constasenaNoCoiniciden }}
                </small>
              </ng-container>
            </div>
            <div class="field col-12 ">
              <label for="passwordRepeat" class="blue-bold-text">{{ translations.repitaContrasena }}<span
                style="color: red">*</span></label>
              <p-password formControlName="passwordRepeat" id="passwordRepeat" [toggleMask]="true" [feedback]="false"/>
              <ng-container *ngIf="form.get('passwordRepeat')?.invalid && form.get('passwordRepeat')?.touched">
                <small id="passwordRepeat-help" class="p-error block">
                  {{ translations.campoRequerido }}
                </small>
              </ng-container>
            </div>
            <div class="field col-12 mt-2">
              <div class="flex justify-content-center">
                <button pButton type="submit" [label]="translations.cambiarContrasena" icon="pi pi-save" iconPos="right"
                        class="tax-app-button w-15rem"></button>
              </div>
            </div>
          </main>
        </div>
      </form>
    </main>
  </section>
</ng-container>
